module.exports = __webpack_public_path__ + "media/images/footer/logo-ulule-539ff71f509cb241852916caba6c5f55.png";